import { DsPinsFiltersInterface } from '../interfaces/ds-pins-filters.interface';
import { BydCleanInstance } from '@sixense/byd-clean-instance';
/**
 * Pin filters when fetching the list of pins.
 */
@BydCleanInstance
export class DsPinsFilters implements DsPinsFiltersInterface {
  [key: string]: string;

  public global?: string;

  public state?: string;

  public emitterId?: string;

  public campaignId?: string;

  public companyId?: string;

  public mapCategoryId?: string;

  public mapId?: string;

  public bimModelId?: string;

  public planUuid?: string;

  /**
   * type of the map (3D or 2D)
   */
  public mapType?: string;

  /**
   * Criticity
   */
  public rating?: string;

  public positionId?: string;

  public creationDateStart?: string;

  public creationDateEnd?: string;

  public updateDateStart?: string;

  public updateDateEnd?: string;

  public dueDateStart?: string;

  public dueDateEnd?: string;

  public lastModificationDate?: string;

  public hasPhoto?: string;

  public hasComment?: string;

  public search?: string;

  public orderSort?: string;

  public orderBy?: string;

  /**
   * Creates an instance of DsPinsFilters.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsPinsFiltersInterface) {
    this.global = jsonData.global;
    this.state = jsonData.state;
    this.emitterId = jsonData.emitterId;
    this.campaignId = jsonData.campaignId;
    this.companyId = jsonData.companyId;
    this.mapCategoryId = jsonData.mapCategoryId;
    this.mapId = jsonData.mapId;
    this.bimModelId = jsonData.bimModelId;
    this.planUuid = jsonData.planUuid;
    this.mapType = jsonData.mapType;
    this.rating = jsonData.rating;
    this.positionId = jsonData.positionId;
    this.creationDateStart = jsonData.creationDateStart;
    this.creationDateEnd = jsonData.creationDateEnd;
    this.updateDateStart = jsonData.updateDateStart;
    this.updateDateEnd = jsonData.updateDateEnd;
    this.dueDateStart = jsonData.dueDateStart;
    this.dueDateEnd = jsonData.dueDateEnd;
    this.lastModificationDate = jsonData.lastModificationDate;
    this.hasPhoto = jsonData.hasPhoto;
    this.hasComment = jsonData.hasComment;
    this.search = jsonData.search;
    this.orderSort = jsonData.orderSort;
    this.orderBy = jsonData.orderBy;
  }
}
